// MARK://dhk8/admin-shell/lib/queries/combos
// Queries tipadas de combos — F1.2 / ADR-0009. El Admin lee combos por el grafo
// federado (subgraph catalog-combos), tenant del JWT (RLS), no por REST /v1/combos. F9.4: escrituras tambien por el grafo (mutations).
import { graphql } from '../../gql/index.js'

export const AdminCombosQuery = graphql(`
  query AdminCombos($q: String, $limit: Int) {
    combos(q: $q, limit: $limit) {
      items {
        id
        tenantId
        name
        description
        priceCents
        active
        createdAt
        updatedAt
        deletedAt
        items {
          id
          comboId
          productId
          quantity
          isOptional
          sortOrder
        }
      }
    }
  }
`)

export const AdminComboQuery = graphql(`
  query AdminCombo($id: ID!) {
    combo(id: $id) {
      id
      tenantId
      name
      description
      priceCents
      pricingMode
      categoryId
      imageUrl
      validFrom
      validUntil
      version
      active
      createdAt
      updatedAt
      deletedAt
      items {
        id
        comboId
        productId
        categoryId
        allowedProductIds
        quantity
        isOptional
        sortOrder
      }
    }
  }
`)


// ── F9.4: escrituras de combos por el grafo (catalog-combos, tenant del JWT, RLS, IDOR-guard) ──
export const AdminCreateComboMutation = graphql(`
  mutation AdminCreateCombo($input: ComboCreateInput!) {
    createCombo(input: $input) {
      id
      tenantId
      name
      description
      priceCents
      pricingMode
      categoryId
      imageUrl
      validFrom
      validUntil
      version
      active
      createdAt
      updatedAt
      deletedAt
      items {
        id
        comboId
        productId
        categoryId
        allowedProductIds
        quantity
        isOptional
        sortOrder
      }
    }
  }
`)

export const AdminUpdateComboMutation = graphql(`
  mutation AdminUpdateCombo($id: ID!, $input: ComboUpdateInput!) {
    updateCombo(id: $id, input: $input) {
      id
      tenantId
      name
      description
      priceCents
      pricingMode
      categoryId
      imageUrl
      validFrom
      validUntil
      version
      active
      createdAt
      updatedAt
      deletedAt
      items {
        id
        comboId
        productId
        categoryId
        allowedProductIds
        quantity
        isOptional
        sortOrder
      }
    }
  }
`)

export const AdminDeleteComboMutation = graphql(`
  mutation AdminDeleteCombo($id: ID!) {
    deleteCombo(id: $id)
  }
`)

export const AdminAddComboItemMutation = graphql(`
  mutation AdminAddComboItem($comboId: ID!, $input: ComboItemAddInput!) {
    addComboItem(comboId: $comboId, input: $input) {
      id
      comboId
      productId
      categoryId
      allowedProductIds
      quantity
      isOptional
      sortOrder
    }
  }
`)

export const AdminRemoveComboItemMutation = graphql(`
  mutation AdminRemoveComboItem($comboId: ID!, $itemId: ID!) {
    removeComboItem(comboId: $comboId, itemId: $itemId)
  }
`)

export const AdminUpdateComboItemMutation = graphql(`
  mutation AdminUpdateComboItem($comboId: ID!, $itemId: ID!, $input: ComboItemUpdateInput!) {
    updateComboItem(comboId: $comboId, itemId: $itemId, input: $input) {
      id
      comboId
      productId
      categoryId
      allowedProductIds
      quantity
      isOptional
      sortOrder
    }
  }
`)
